import { useState } from "react";
import { Outlet } from "react-router";
import clsx from "clsx";
import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/Sidebar";
import { useI18n } from "@/hooks/useI18n";

/** Width of the minimalist icon rail. */
const RAIL_WIDTH_CLASS = "lg:w-[76px]";
const FULL_WIDTH_CLASS = "lg:w-72";
const RAIL_OFFSET_CLASS = "lg:pl-[76px]";
const FULL_OFFSET_CLASS = "lg:pl-72";

export function AppShell() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const { t } = useI18n();

    const toggleCollapsed = () => setCollapsed((prev) => !prev);

    return (
        <div className="app-page-scaffold min-h-screen">
            {/* Desktop sidebar */}
            <aside
                className={clsx(
                    "app-shell-panel fixed inset-y-0 left-0 z-30 hidden border-r app-shell-border transition-[width] duration-200 ease-out lg:block",
                    collapsed ? RAIL_WIDTH_CLASS : FULL_WIDTH_CLASS,
                )}
            >
                <Sidebar collapsed={collapsed} onToggleCollapsed={toggleCollapsed} />
            </aside>

            {/* Mobile sidebar */}
            {mobileOpen && (
                <div className="fixed inset-0 z-40 lg:hidden">
                    <button
                        type="button"
                        aria-label={t("header.closeNavigation")}
                        className="absolute inset-0 bg-black/40"
                        onClick={() => setMobileOpen(false)}
                    />
                    <aside className="app-shell-panel absolute inset-y-0 left-0 w-72 border-r app-shell-border">
                        <Sidebar onNavigate={() => setMobileOpen(false)} />
                    </aside>
                </div>
            )}

            <div
                className={clsx(
                    "transition-[padding] duration-200 ease-out",
                    collapsed ? RAIL_OFFSET_CLASS : FULL_OFFSET_CLASS,
                )}
            >
                <Header onOpenSidebar={() => setMobileOpen(true)} />

                <main className="w-full px-5 py-8 sm:px-8">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
